<template>
  <div>
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
		:is-full-page="true"></loading>
    <Header />
    <div class="container">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      ></loading>
      <div class="merchant">
        <h3>Apply Now For Merchant</h3>
        <form action="" @submit.stop.prevent="">
          <span class="pull-right"><strong>Step 3 / 3</strong></span>
          <div class="row">
            <h3>Agreement and Conditions</h3>
          </div>
          <div class="row mt-0">
            <div class="col-12">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Enim nobis iure nulla quis accusamus facilis rem quasi ipsa unde repellendus cumque consequatur, tenetur eum similique vel perspiciatis rerum repudiandae hic.</div>
          </div>
          <div class="row ">
            <div class="col-12">
              <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
                I accept the agreement and conditions
              </b-form-checkbox>
            </div>
          </div>
          
          <div class="row ">
            <div class="col-3">
              <router-link :to="{ name: 'merchant-extended' }">
                <button>
                  <h3>Back</h3>
                </button>
              </router-link>
            </div>
            <div class="col-lg-3">
              <button type="submit" @click="submitApply">
                <h3>Submit Form</h3>
              </button>
            </div>
             <div class="col-lg-3">
              <button type="submit" @click="generatePdf()">
                <h3>Download</h3>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Call To Action -->
    <section class="call-to-action text-center" id="call-to-action">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <!-- <img src="../../assets/icons/wallet.svg" alt=""> -->
            <h3>Get your Safe Money Wallet today.</h3>
            <router-link :to="{ name: 'app' }">Get Now</router-link>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <SubscribeForm source="Merchant application"></SubscribeForm>
</div>
        </div>
      </div>
    </section>

    <b-toast
      id="error-toast"
      variant="warning"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Required error</strong>
      </div>

      <div v-if="errors.status">
        <p>{{ errors.status }}</p>
      </div>
      <div v-else-if="errormessage='errormessage'">
        <p>{{ message }}</p>
      </div>
    </b-toast>

    <b-toast
      id="success-toast"
      variant="success"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Merchant Request Submit Success</strong>
      </div>

      <div>
        <p>
          Merchant Request Submmitted Successfully. We will follow you after
          review the request detail.<br />AMEJPAY TEAM
        </p>
      </div>
    </b-toast>

    <!------------- -------------------------- ----------------->
    <div v-if="showdiv" id="testHtml">
      <div style="width: 94%; padding: 2% 3% ; font-family: inherit; font-size: 11px;">
        <h3 style="font-size: 21px; font-weight: bold;">New Merchant Form</h3>
        <div class="table table-responsive">
          <p style="font-size: 11px; line-height: 16px;">
            Hi {{merchantFormData.contact_name}},<br/>
            Thank you for joining Amejpay Merchant Platform. Please print this document, <br/>
            signed it and re-upload from your newely created Amejpay  Merchant User dashboard.<br/>
            After you upload this  signed document to us, we can verify your merchant account.<br>
          </p>
          <p style="font-size: 11px;">Your Merchant Form details are as follows: </p>
          <table width="100%" style="width: 100%; font-size: 11px;" border="0" cellspacing="0" cellpadding="0">
            <body style="width: 100%;">
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Owner Name</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.owner_name}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Company Name</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.company_name}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Company Website</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.company_website}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Company Email</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.business_email}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Company Phone Number</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.business_phone}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Contact Name</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.contact_name}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Contact Number</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.contact_number}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Contact Email</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.contact_email}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Business Registration Number</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.business_reg_number}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">VAT/PAN/GST Number</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; padding: 0.10rem;">{{merchantFormData.vatpangstnumber}}</td></tr>
              <tr><th style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Business Address</th><td style="padding: 0.10rem;"> : </td><td style="font-size: 11px; line-height: 21px; padding: 0.10rem;">
                <span v-if="merchantFormData.business_addressline">{{merchantFormData.business_addressline}}</span>
                <span v-if="merchantFormData.business_address_city">, {{merchantFormData.business_address_city}}</span>
                <span v-if="merchantFormData.business_address_state">,<br/>{{merchantFormData.business_address_state}}</span>
                <span v-if="merchantFormData.business_address_zipcode">, {{merchantFormData.business_address_zipcode}}</span>
                <span v-if="merchantFormData.business_address_country">, {{countryName.name}}</span>
              </td></tr>
              <tr>
                <td colspan="3" style="font-size: 11px; font-weight: bold; padding: 0.10rem;">
                  I accpet Accept all the terms and conditions of Amejpay Merchant.
                </td>
              </tr>
              <tr>
                <td style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Authorize Signature</td>
                <td style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Company Stamp</td>
              </tr>
              <tr>
                <td>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                </td>
                <td>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                </td>
              </tr>
              <tr>
                <td colspan="3" style="font-size: 11px; font-weight: bold; padding: 0.10rem;">Date: </td>
              </tr>
            </body>
          </table>
        </div>
      </div>
    </div>
    <!------------- -------------------------- ----------------->

    <Footer />
  </div>
</template>
<script>
import Header from "./HeaderNew.vue";
import SubscribeForm from "./SubscribeForm.vue";
import Footer from "./FooterNew.vue";
import Loading from "vue-loading-overlay";
import { jsPDF } from "jspdf";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapActions, mapState } from "vuex";

export default {
  components: { SubscribeForm,
    Footer,
    Header,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      onChangeStateValue: "",
      merchantFormData: JSON.parse(localStorage.getItem('merchantFormData')),
      errors: [],
      status: '',
      ApplyformSubmit: false,
      showdiv: false,
    };
  },
  created() {
    this.listCountries();
  },
  computed: {
    ...mapState(["successmessage", "errormessage", "message", "countries"]),
    countryName: function() {
      let allCountry = this.countries;
      let countryName = '';
      countryName = allCountry.find((item) => {
        return item.id == this.merchantFormData.business_address_country
      });

      return countryName;
    }
  },
  methods: {
    ...mapActions(["listCountries"]),
    submitApply(e) {
      e.preventDefault();
      this.ApplyFormSubmit = false;
      this.errors = [];
      if (this.status == "" || this.status.legth < 1) {
        this.errors["status"] = "Please accept the agreement and conditions.";
        this.$bvToast.show("error-toast");
      } else {
        this.isLoading = true;
        let formData = new FormData();
        formData.append("owner_name", this.merchantFormData.owner_name);
        formData.append("business_phone", this.merchantFormData.business_phone);
        formData.append("business_email", this.merchantFormData.business_email);
        formData.append("contact_name", this.merchantFormData.contact_name);
        formData.append("contact_number", this.merchantFormData.contact_number);
        formData.append("contact_email", this.merchantFormData.contact_email);
        formData.append("company_name", this.merchantFormData.company_name);
        formData.append("company_website", this.merchantFormData.company_website);
        formData.append("business_reg_number",this.merchantFormData.business_reg_number);
        formData.append("vatpangstnumber", this.merchantFormData.vatpangstnumber);
        formData.append("business_addressline", this.merchantFormData.business_addressline);
        formData.append("country", this.merchantFormData.business_address_country);
        formData.append("business_address_city", this.merchantFormData.business_address_city);
        formData.append("business_address_state", this.merchantFormData.business_address_state);
        formData.append("business_address_zipcode", this.merchantFormData.business_address_zipcode);
        formData.append("message", "");
        formData.append("ip_address", "");
        formData.append("status", "submit");
        formData.append("email_verify_link", process.env.VUE_APP_EMAIL_URL);

        // for (var pair of formData.entries()) {
        //   console.log(pair[0]+ ', ' + pair[1]);
        // }

        this.$store.dispatch("registerMerchant", formData).then(() => {
          this.isLoading = false;
          if (this.successmessage == "success") {
            this.$bvToast.show("success-toast");
            localStorage.removeItem('merchantFormData');
            setTimeout(() => {
              this.$router.replace({
                name: 'home'
              })
            }, 3000);
          } else if (this.errormessage == "errormessage") {
            this.$bvToast.show("error-toast");
          }
        });

      }
    },
    generatePdf(){
      this.showdiv = true
      
      setTimeout(() => {
        this.isLoading = true
        var pdf = new jsPDF('p', 'pt', 'A4');
        pdf.html(document.getElementById('testHtml'), {
          callback: function (pdf) {
            pdf.save('amejpay_merchant_registration_authorize_form.pdf');
          }
        });
      }, 200);

      setInterval(() => {
        this.isLoading = false
        this.showdiv = false
      }, 2500);
    },
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  },
};
</script>
<style lang="scss" scoped>
.merchant {
  padding-block-start: 120px;

  h3 {
    color: #000;
    text-align: center;
    margin-block-end: 20px;
    font-size: 20px;
  }
  form {
    background: #f7f9fa;
    border: 1px solid rgba(0, 0, 0, 0.14);
    padding: 54px 43px;
    margin-bottom: 100px;
    button {
      background: #ed1a3b;
      color: #fff;
      border: none;
      height: 70px;
      width: 100%;
      border-radius: 30px;
      padding-top: 15px;
      padding-left: 30px;
      &:hover {
        background: #c70926;
      }
      h3 {
        color: #fff;
        text-align: left;
        font-size: 24px;
        font-weight: 700;
      }
    }
    input {
      width: 100%;
      font-size: 18px;
      font-family: "Poppins", sans-serif;
      height: 70px;
    }
    label {
      width: 100%;
      h3 {
        text-align: left;
      }
      input {
        width: 100%;
        margin: 0px;
      }
    }
  }
}
</style>